export const NO_UNITS_URL = 'https://files.dxr.cloud/wWCmulmunGs6Hwrn7EX3IY3ne8uNC7jLF6uhrkSZOROD1m07vLMxrA5E.svg';
export const AVATAR_URL = 'https://files.dxr.cloud/ifyNhCbD4kt7c4DYs6Xo7q0DJuxAP4IVfucD2EhVNy5ecRunnSb5SlHs.svg';
